import moment from 'moment';

const formatDate = (value, format = 'MM/DD/YYYY') => {
  return moment(value).format(format);
};

export default formatDate;
